import { render } from "./WebcamComponent.vue?vue&type=template&id=4bbcd6f3"
import script from "./WebcamComponent.vue?vue&type=script&lang=js"
export * from "./WebcamComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__